/**
 * Created by Pawan on 6/9/2017.
 */

import _ from 'lodash';
import {FuidRrnInfo} from "../autogenerated/ZoomBridge";

export default class ArrayUtil {
  static emptyArray(): Array {}

  static isNotEmpty(arr) {
    return !ArrayUtil.isEmpty(arr);
  }

  static isEmpty(arr) {
    return ArrayUtil.isNull(arr) || arr.length === 0;
  }

  static isNull(arr) {
    return !arr || arr === null;
  }

  static areEqual(array1 = [], array2 = [], idProperty = 'id') {
    const array1Ids = array1.map((o) => o[idProperty]);
    const array2Ids = array2.map((o) => o[idProperty]);
    return _.isEqual(array1Ids.sort(), array2Ids.sort());
  }

  static areDeepEqual(array1 = [], array2 = []) {
    return _.isEqual(array1, array2);
  }
}

export function pushFuidRrnInfoInArray(fuid, rrn, fuidRrnInfoArray) {
  const info = new FuidRrnInfo();
  info.setFuid(fuid);
  info.setRrn(rrn);
  info.setBid(1);
  fuidRrnInfoArray.push(info);
}
